import SpecialSale from 'src/dispensary/specials/sale';
import { MainDispensaryLayout } from 'components/layouts/main-dispensary-layout';

SpecialSale.layout = MainDispensaryLayout;
export default SpecialSale;
